export const abbreviations = [
    // Feeding
    {
        sno: 1,
        key_terms: '1KG Dispense Feed',
        full_form: '1KG Dispense Feed',
        meaning: 'The time taken (in seconds) by the feeder to dispense 1 Kg of feed.',
        category: 'Feeding',
    },
    {
        sno: 2,
        key_terms: 'TF',
        full_form: 'Total Feed',
        meaning: 'Total feed configured by the user for the existing schedule.',
        category: 'Feeding',
    },
    {
        sno: 3,
        key_terms: 'DF',
        full_form: 'Dispensed Feed',
        meaning: 'The amount of feed dispensed by the feeder in the current feeding schedule.',
        category: 'Feeding',
    },
    {
        sno: 4,
        key_terms: 'Feed Cycle',
        full_form: 'Feed Cycle',
        meaning: 'A feed cycle is an interval of time that consists of one period each of feed dispenser ON and OFF.',
        category: 'Feeding',
    },
    {
        sno: 5,
        key_terms: 'OCF',
        full_form: 'One Cycle Feed',
        meaning: 'The amount of feed to be dispensed in one feed cycle.',
        category: 'Feeding',
    },
    {
        sno: 6,
        key_terms: 'FGI',
        full_form: 'Feed Gap Interval',
        meaning: 'The time gap between start of two successive feed cycles.',
        category: 'Feeding',
    },
    {
        sno: 7,
        key_terms: 'Mode',
        full_form: 'Feeding Mode',
        meaning: 'The mode of operation of the feeder. The feeder can support a simple set of configuration options known as the "Basic Mode" or an advanced set known as the "Schedule Mode".',
        category: 'Feeding',
    },
    {
        sno: 8,
        key_terms: 'ON Time',
        full_form: 'ON Time',
        meaning: 'The amount of time that the motor is ON and the feed is dispensed during a feed cycle.',
        category: 'Feeding',
    },
    {
        sno: 9,
        key_terms: 'OFF Time',
        full_form: 'OFF Time',
        meaning: 'The amount of time that the motor is OFF and the feed is not dispensed during a feed cycle.',
        category: 'Feeding',
    },
    {
        sno: 10,
        key_terms: 'Schedule',
        full_form: 'Feeding Schedule',
        meaning: 'A combination of multiple feed cycles that have the same set of parameters.',
        category: 'Feeding',
    },
    // Growth
    {
        sno: 11,
        key_terms: 'ABW',
        full_form: 'Average Body Weight',
        meaning: 'Average body weight of shrimp sampled from the pond, used to track growth progress.',
        category: 'Growth',
    },
    {
        sno: 12,
        key_terms: 'AWG',
        full_form: 'Average Weekly Growth',
        meaning: 'Average weekly weight gain of shrimp, calculated from consecutive ABW sampling events.',
        category: 'Growth',
    },
    {
        sno: 13,
        key_terms: 'ADG',
        full_form: 'Average Daily Growth',
        meaning: 'Average daily weight gain of shrimp, derived from ABW measurements over a given period.',
        category: 'Growth',
    },
    {
        sno: 14,
        key_terms: 'FCR',
        full_form: 'Feed Conversion Ratio',
        meaning: 'Feed Conversion Ratio — total feed dispensed divided by total biomass gained. A lower FCR indicates better feed efficiency.',
        category: 'Growth',
    },
    // Culture
    {
        sno: 15,
        key_terms: 'SOC',
        full_form: 'Start of Culture',
        meaning: 'The date on which shrimp post-larvae were stocked into the pond.',
        category: 'Culture',
    },
    {
        sno: 16,
        key_terms: 'DOC',
        full_form: 'Days of Culture',
        meaning: 'Number of days elapsed since shrimp were stocked (since SOC).',
        category: 'Culture',
    },
    {
        sno: 17,
        key_terms: 'HOC',
        full_form: 'Harvest of Culture',
        meaning: 'The harvest event that concludes a production cycle.',
        category: 'Culture',
    },
    // Water Quality
    {
        sno: 18,
        key_terms: 'DO',
        full_form: 'Dissolved Oxygen',
        meaning: 'Dissolved Oxygen (mg/l) — the concentration of oxygen dissolved in pond water. Critical for shrimp survival; low DO triggers alarms.',
        category: 'Water Quality',
    },
    {
        sno: 19,
        key_terms: 'TAN',
        full_form: 'Total Ammonia Nitrogen',
        meaning: 'Sum of ionised (NH₄⁺) and un-ionised (NH₃) ammonia. Elevated TAN is toxic to shrimp and indicates poor water quality.',
        category: 'Water Quality',
    },
    {
        sno: 20,
        key_terms: 'NH4',
        full_form: 'Ammonium',
        meaning: 'Ammonium ion (NH₄⁺) — the ionised, relatively non-toxic form of ammonia measured in pond water (ppm).',
        category: 'Water Quality',
    },
    {
        sno: 21,
        key_terms: 'ppt',
        full_form: 'Parts Per Thousand',
        meaning: 'The unit used to measure salinity of pond water (e.g., 15 ppt salinity).',
        category: 'Water Quality',
    },
    // Chemical & Minerals
    {
        sno: 22,
        key_terms: 'Ca',
        full_form: 'Calcium',
        meaning: 'Calcium concentration (ppm) in pond water — important for shell formation and water hardness balance.',
        category: 'Chemical & Minerals',
    },
    {
        sno: 23,
        key_terms: 'Mg',
        full_form: 'Magnesium',
        meaning: 'Magnesium concentration (ppm) in pond water — contributes to water hardness and osmoregulation in shrimp.',
        category: 'Chemical & Minerals',
    },
    {
        sno: 24,
        key_terms: 'K',
        full_form: 'Potassium (Kali)',
        meaning: 'Potassium concentration (ppm) in pond water — essential mineral for shrimp health and osmoregulation.',
        category: 'Chemical & Minerals',
    },
    {
        sno: 25,
        key_terms: 'Fe',
        full_form: 'Iron',
        meaning: 'Iron concentration (ppm) in pond water — elevated levels can cause oxidation stress and affect feed palatability.',
        category: 'Chemical & Minerals',
    },
    {
        sno: 26,
        key_terms: 'NO2',
        full_form: 'Nitrite',
        meaning: 'Nitrite concentration (ppm) in pond water — a toxic intermediate in the nitrogen cycle; high NO₂ causes brown blood disease in shrimp.',
        category: 'Chemical & Minerals',
    },
    // Organic Load
    {
        sno: 27,
        key_terms: 'NTU',
        full_form: 'Nephelometric Turbidity Units',
        meaning: 'Unit for measuring water turbidity (cloudiness). Higher NTU values indicate more suspended particles in pond water.',
        category: 'Organic Load',
    },
    // Microbiology
    {
        sno: 28,
        key_terms: 'CFU/ml',
        full_form: 'Colony Forming Units per Millilitre',
        meaning: 'The number of viable bacterial colonies per millilitre of water sample, used to quantify Vibrio and total bacteria.',
        category: 'Microbiology',
    },
    {
        sno: 29,
        key_terms: 'V. Vulnificus',
        full_form: 'Vibrio Vulnificus',
        meaning: 'A pathogenic Vibrio species associated with severe infections in shrimp. Monitored in lab tests (CFU/ml).',
        category: 'Microbiology',
    },
    {
        sno: 30,
        key_terms: 'V. Parahaemolyticus',
        full_form: 'Vibrio Parahaemolyticus',
        meaning: 'The causative agent of Acute Hepatopancreatic Necrosis Disease (AHPND / EMS) in shrimp. Critical to monitor in hatchery and pond water.',
        category: 'Microbiology',
    },
    {
        sno: 31,
        key_terms: 'V. Alginolyticus',
        full_form: 'Vibrio Alginolyticus',
        meaning: 'An opportunistic Vibrio species found in marine environments. Elevated counts indicate water quality deterioration.',
        category: 'Microbiology',
    },
    {
        sno: 32,
        key_terms: 'TBC',
        full_form: 'Total Bacteria Count',
        meaning: 'Total Bacteria Count (CFU/ml) — the overall bacterial load in a water sample, indicating general microbial quality of the pond.',
        category: 'Microbiology',
    },
    // Device
    {
        sno: 33,
        key_terms: 'GW',
        full_form: 'Gateway',
        meaning: 'PondLogs LoRa-to-cloud bridge device that relays data from pond devices to the server.',
        category: 'Device',
    },
    {
        sno: 34,
        key_terms: 'PM',
        full_form: 'PondMother',
        meaning: 'PondLogs smart automatic feeder device.',
        category: 'Device',
    },
    {
        sno: 35,
        key_terms: 'PM75',
        full_form: 'PondMother with 75kg hopper',
        meaning: 'PondMother variant with a 75 kg feed hopper capacity.',
        category: 'Device',
    },
    {
        sno: 36,
        key_terms: 'PM125',
        full_form: 'PondMother with 125kg hopper',
        meaning: 'PondMother variant with a 125 kg feed hopper capacity.',
        category: 'Device',
    },
    {
        sno: 37,
        key_terms: 'PM250-S',
        full_form: 'PondMother with 250kg square hopper',
        meaning: 'PondMother variant with a 250 kg square hopper.',
        category: 'Device',
    },
    {
        sno: 38,
        key_terms: 'PM250-C',
        full_form: 'PondMother with 250kg circular hopper',
        meaning: 'PondMother variant with a 250 kg circular hopper.',
        category: 'Device',
    },
    {
        sno: 39,
        key_terms: 'PM250 Max (S)',
        full_form: 'PondMother with 250kg Max square hopper',
        meaning: 'High-capacity PondMother with 250 kg Max square hopper.',
        category: 'Device',
    },
    {
        sno: 40,
        key_terms: 'PM250 Max (C)',
        full_form: 'PondMother with 250kg Max circular hopper',
        meaning: 'High-capacity PondMother with 250 kg Max circular hopper.',
        category: 'Device',
    },
    {
        sno: 41,
        key_terms: 'PG',
        full_form: 'PondGuard',
        meaning: 'PondLogs DO sensor and alarm device placed in the pond.',
        category: 'Device',
    },
    {
        sno: 42,
        key_terms: 'ST',
        full_form: 'ShrimpTalk',
        meaning: 'PondLogs shrimp activity and feeding response sensor.',
        category: 'Device',
    },
];
